import { i18n } from '@fs/zion-locale'
import { format } from '@fs/zion-locale/date-fns'

// To cause less disturbance we are formatting dates like the backend did when in the en locale. We may change later to just using the international standard (the en-GB style that format defaults to)

/** Formats as November 20, 2024 for the en (US) locale, otherwise the locale default (e.g. 20 November 2024) */
export function formatDate(ms: number): string {
  return i18n.language === 'en' ? format(ms, 'MMMM d, yyyy') : format(ms)
}
